import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import isArray from 'lodash/isArray'
import Thread from './thread'
import MessageHelp from './message-help'

const ThreadList = ({ threads, params, userId, indexRead }) => {
  return (
    <div className="threads lg:w-3/12 w-full border-l shadow relative lg:flex lg:flex-col flex-row">
      <div className="threads-container lg:overflow-y-auto lg:h-full max-h-14 ">
        {threads &&
          threads.length > 0 &&
          threads.map((thread, key) => {
            const date = moment(thread.date).format('MMMM DD')
            const sender = thread.members.find((member) => member.id !== userId)
            if (!sender) {
              console.log(`not found sender: ${thread.id}`)
            }
            const isRead = thread.id === indexRead.id ? indexRead.isRead : thread.is_read
            let lastMessage = thread.lastMessage
            if (isArray(lastMessage)) {
              lastMessage = `Sent ${lastMessage.length} attachment(s)`
            }
            return (
              <Thread
                key={key}
                link={`/client/messages/${
                  typeof Number(params.filter) === 'number'
                    ? thread.id
                    : `${params.filter}/${thread.id}`
                }/conversation`}
                username={sender?.name}
                isRead={isRead}
                lastMessage={lastMessage}
                avatar={sender?.profile?.avatar || ''}
                date={date}
                status={thread.status}
              />
            )
          })}
      </div>
      <div className="max-h-max">
        <MessageHelp />
      </div>
    </div>
  )
}

ThreadList.propTypes = {
  threads: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      lastMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      avatar: PropTypes.string,
      title: PropTypes.string,
      date: PropTypes.string,
    })
  ),
  params: PropTypes.object,
  userId: PropTypes.number,
  indexRead: PropTypes.object,
}

const mapStateToProps = ({ messages, auth }) => ({
  threads: messages.conversation.list,
  userId: auth.user.id,
  indexRead: {
    isRead: messages.index.is_read,
    id: messages.index.id,
  },
})

export default connect(mapStateToProps)(ThreadList)
